import { Box, Grid, styled, Typography } from '@mui/material';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-left: 2px solid var(--divider, rgba(0, 0, 0, 0.12));
`;

export const ComponentTitleContainer = styled(Box)<{
  $isReplacementComponent?: boolean;
}>`
  display: flex;
  justify-content: ${({
    $isReplacementComponent,
  }: {
    $isReplacementComponent?: boolean;
  }) => ($isReplacementComponent ? 'end' : 'space-between')};
  align-items: center;
`;

export const ComponentContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.brand.whitesmoke,
  border: `1px solid ${theme.palette.brand.disable}`,
  borderRadius: '4px',
  overflow: 'hidden',
  height: '350px',
  minWidth: '260px', // compensating container padding
}));

export const CardInfoTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  overflow-wrap: anywhere;
  width: 100%;
`;

export const CardInfoDescription = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const CardButtonContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

export const StyledChipContainer = styled(Box)`
  margin: 5px 5px 5px 0;
  display: inline-block;
`;

export const StyledDynamicTooltipChip = styled(DynamicTooltipChip)`
  max-width: 272px;
`;
